export enum MultiLang {
  EN = "en",
  JP = "jp",
}
